import { Button } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
export var submitSuccess = function submitSuccess(t) {
  return {
    severity: 'success',
    message: t('Your changes have been saved'),
    duration: 'medium'
  };
};
export var submitFailure = function submitFailure(onRetry, t) {
  return {
    severity: 'error',
    message: t('Sorry, we were unable to save your changes'),
    duration: 'medium',
    action: /*#__PURE__*/_jsx(Button, {
      color: "inherit",
      size: "small",
      onClick: onRetry,
      children: t('Retry')
    })
  };
};
export var imageRemoveFailure = function imageRemoveFailure(t) {
  return {
    severity: 'error',
    message: t('Sorry, we were unable to remove your photo'),
    duration: 'medium'
  };
};
export var imageSubmitFailure = function imageSubmitFailure(t) {
  return {
    severity: 'error',
    message: t('Sorry, we were unable to upload your photo'),
    duration: 'medium'
  };
};
export var statusUpdateFailure = function statusUpdateFailure(t) {
  return {
    severity: 'error',
    message: t('Sorry, we were unable to finish completing your onboarding'),
    duration: 'medium'
  };
};